
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/shipping/search",
      function () {
        return require("private-next-pages/shipping/search.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/shipping/search"])
      });
    }
  